import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { RetryLink } from '@apollo/client/link/retry'
import { setContext } from '@apollo/client/link/context'
import { AuthToken } from '@/store/auth/auth-token'
import { getLanguageCode } from '@/locales/i18n'

export default class GraphqlClient {
  static initApolloClient(backendUrl) {
    if (!backendUrl) {
      console.error('The backendUrl is required')
      return
    }

    const retryLink = new RetryLink({
      attempts: {
        max: 2
      }
    })

    const authLink = setContext(async (_, { headers }) => {
      const token = await AuthToken.get()
      return {
        headers: {
          ...headers,
          'Access-Control-Allow-Origin': '*',
          authorization: token ? `Bearer ${token}` : '',
          'Accept-Language': getLanguageCode(),
          'application-type': 'web'
        }
      }
    })

    const httpLink = createHttpLink({
      uri: `${backendUrl}`
    })

    const defaultOptions = {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      }
    }

    const graphqlClient = new ApolloClient({
      link: retryLink.concat(authLink.concat(httpLink)),
      cache: new InMemoryCache({
        addTypename: false
      }),
      defaultOptions
    })

    return graphqlClient
  }
}
